import { MegaMenuDesignTokens } from '@primeuix/themes/types/megamenu';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t, tDeep, tFlat } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/megamenu/index.ts
const mm = componentCommon.megamenu;
const mmDeep = tDeep(mm);

export const MegaMenuTelekomDT: MegaMenuDesignTokens = {
  root: {
    background: t(mm.background),
    borderColor: t(mm.border.color),
    borderRadius: t(mm.border.radius),
    color: t(mm.color),
    gap: t(mm.gap),
    verticalOrientation: {
      padding: `${mmDeep.vertical.orientation.padding.y} ${mmDeep.vertical.orientation.padding.x}`,
      gap: t(mm.vertical.orientation.gap),
    },
    horizontalOrientation: {
      padding: `${mmDeep.horizontal.orientation.padding.y} ${mmDeep.horizontal.orientation.padding.x}`,
      gap: t(mm.horizontal.orientation.gap),
    },
  },
  baseItem: {
    borderRadius: t(mm.base.item.border.radius),
    padding: `${mmDeep.base.item.padding.y} ${mmDeep.base.item.padding.x}`,
  },
  item: {
    focusBackground: t(mm.item.focus.background),
    activeBackground: t(mm.item.active.background),
    color: t(mm.item.color),
    focusColor: t(mm.item.focus.color),
    activeColor: t(mm.item.active.color),
    padding: `${mmDeep.item.padding.y} ${mmDeep.item.padding.x}`,
    borderRadius: t(mm.item.border.radius),
    gap: t(mm.item.gap),
    icon: {
      color: t(mm.item.icon.color),
      focusColor: t(mm.item.icon.focus.color),
      activeColor: t(mm.item.icon.active.color),
    },
  },
  overlay: {
    padding: t(mm.overlay.padding),
    background: t(mm.overlay.background),
    borderColor: t(mm.overlay.border.color),
    borderRadius: t(mm.overlay.border.radius),
    color: t(mm.overlay.color),
    gap: t(mm.overlay.gap),
  },
  submenu: {
    padding: `${mmDeep.submenu.padding.y} ${mmDeep.submenu.padding.x}`,
    gap: t(mm.submenu.gap),
  },
  submenuLabel: {
    padding: `${mmDeep.submenu.label.padding.y} ${mmDeep.submenu.label.padding.x}`,
    background: t(mm.submenu.label.background),
    color: t(mm.submenu.label.color),
  },
  submenuIcon: {
    size: t(mm.submenu.icon.size),
    color: t(mm.submenu.icon.color),
    focusColor: t(mm.submenu.icon.focus.color),
    activeColor: t(mm.submenu.icon.active.color),
  },
  separator: {
    borderColor: t(mm.separator.border.color),
  },
  mobileButton: {
    borderRadius: t(mm.mobile.button.border.radius),
    size: t(mm.mobile.button.size),
    color: t(mm.mobile.button.color),
    hoverColor: t(mm.mobile.button.hover.color),
    hoverBackground: t(mm.mobile.button.hover.background),
    focusRing: tFlat(mm.mobile.button.focus.ring),
  },
};
